import { useState } from "react";
import { AdminModulesSection, AdminLessonsSection, AdminFlashcardsSection, AdminRoleplaysSection } from "@/pages/Admin";

const SUB = [
    { key: "modules", label: "Modules", Comp: AdminModulesSection },
    { key: "lessons", label: "Lessons", Comp: AdminLessonsSection },
    { key: "flashcards", label: "Flash cards", Comp: AdminFlashcardsSection },
    { key: "roleplays", label: "Roleplays", Comp: AdminRoleplaysSection },
];

export default function AdminModulesPage() {
    const [s, setS] = useState("modules");
    const Active = SUB.find((x) => x.key === s)?.Comp;
    return (
        <div className="space-y-6" data-testid="admin-modules-page">
            <div className="flex gap-2 flex-wrap">
                {SUB.map((x) => (
                    <button key={x.key} onClick={() => setS(x.key)}
                        data-testid={`admin-modules-sub-${x.key}`}
                        className={`px-3 py-1.5 text-xs font-mono uppercase tracking-[0.15em] rounded-sm border transition-colors ${
                            s === x.key ? "bg-haevn-700 text-white border-haevn-700" : "bg-white text-ink-500 border-ink-300 hover:border-haevn-700 hover:text-ink-900"
                        }`}>{x.label}</button>
                ))}
            </div>
            {Active && <Active />}
        </div>
    );
}
